import React from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import StepForm from "../state-transition/StateTransition";
import './Terms.css';
import moment from 'moment';
import { constants } from '../../constants';
import {
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails,
  resetReviewDetails,
  acceptedTermsAndConditions,
  getTermsAndConditions,
  getExamSeriesError,
  getInstitutionsError,
  updateAdyenFlag
} from '../../redux-building-blocks/actions';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import { Spinner } from 'react-bootstrap';
import UtilityService from '../../services/utility.service';
import MulesoftDataService from '../../services/mulesoftData.services';
import nodeDataService from '../../services/nodeData.services';
import Modal from '../shared/modal/Modal';
export class TermsAndConditions extends React.Component {
  constructor(props){
    super(props);
    this.state={
      checkDisable: true,
      acceptBtnDisable:true,
      turnaroundTimeText:'',
      hashString:"",
      acceptedTerms:false,    
      orderId : this.props.confirmationInfo.requestId+"-"+ new Date().getTime(),
      paymentDueDate: this.props.confirmationInfo.paymentDueDate,
      applicationSubmittedDate: this.props.confirmationInfo.applicationSubmittedDate,
      applicationReferenceNumber: this.props.confirmationInfo.requestId,
      overlay: false,
      modalType: ''
    };
  }
  componentDidMount(){
    this.setState({spinner:true});    
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event){
        window.history.pushState(null, document.title,  window.location.href);
    });
    this.calculateSeries();
    if(isEmpty(this.props.terms)){
      this.props.getTermsAndConditions(uuidv4());
      this.setState({spinner:false});
    }else{
      this.setState({spinner:false});
    }
  }
  reDirectToHistory = () =>{
    if(this.props.stateNavFlags.isHistoryPayNav){
      this.props.getExamSeriesError();
      this.props.getInstitutionsError();
    }
    this.props.resetPersonalInfoData();
    this.props.restExamDetails();
    this.props.restInstitutionDetails();    
    this.props.history.push('/transcript-history')
  }
  handleButtonClick = async (e, args) => {
    e.preventDefault(); 
    const response = await MulesoftDataService.validatePaymentDue(args)
    
    // Log payment status after validate payment response
    if (response && response.data) {
      const paymentStatusData = {
        applicationReferenceNumber: response.data.applicationReferenceNumber,
        paymentCompleted: response.data.paymentCompleted,
        breached: response.data.breached,
        paymentDueDate: response.data.paymentDueDate,
        actionName: 'Accept and Pay Clicked'
      };
      
      // Log payment status (non-blocking)
      nodeDataService.logPaymentStatus(paymentStatusData)
        .then(() => console.log('Payment status logged successfully'))
        .catch(err => console.error('Error logging payment status:', err));
    }
    
    if (response && response.data && response.data.breached === true) {
      this.setState({
        overlay: true,
        modalType: 'paymentDue'
      })
    } else if (response && response.data && response.data.paymentCompleted === true) {
      this.setState({
        overlay: true,
        modalType: 'duplicatePayment'
      })
    } else {
      this.props.updateAdyenFlag();
      this.props.history.push('/adyenPayment');
    }    
  }    
  scrollToBottom = e => {
    let heightScrolled = e.target.scrollHeight - Math.floor(e.target.scrollTop);
    if(heightScrolled - e.target.clientHeight >=0 && heightScrolled - e.target.clientHeight <=100 && this.state.checkDisable){
        this.setState({checkDisable:false});
    }
  }  
  acceptTerms(aRefNum){
    const {acceptBtnDisable,acceptedTerms} = this.state;
    if(!acceptedTerms){
      this.props.acceptedTermsAndConditions({
          appRefNum:aRefNum,
          req:{termsAndConditions: {
                isAccepted: true,       
                dateTime: new Date()       
          },
          tId:uuidv4()
      }})
      this.setState({acceptBtnDisable:!acceptBtnDisable,acceptedTerms:!acceptedTerms});
    }else{
      this.setState({acceptBtnDisable:!acceptBtnDisable});
    }
  }  
  calculateSeries(){
    const date = new Date();
    const currentYear= date.getFullYear();
    const currentMonth = date.getMonth()+1;
    let selectedMonth,selectedYear,seriesArr=[],
        isPastSeries= false, isFutureSeries=false;

        if(this.props.stateNavFlags.isHistoryPayNav){
          for (let str of this.props.examSeries){
            let yearArr = str.session.match(constants.monthYearRegex.year),
                monthArr = str.session.match(constants.monthYearRegex.month);
            seriesArr = [{'examSeries':{year:yearArr[0],month: monthArr[0]}}]
          }
        }else{
            seriesArr = this.props.examDetailsList;
        }        
     
    for(let i=0;i<seriesArr.length;i++){
      const {month,year} = seriesArr[i].examSeries;
      selectedYear = parseInt(year);
      selectedMonth = this.getMonthInNumberFormat(month);
      if((selectedYear> currentYear) || (selectedYear===currentYear && selectedMonth > currentMonth) || (selectedYear===currentYear && selectedMonth === currentMonth)){
        isFutureSeries = true;
       }
       else if((selectedYear < currentYear) || (selectedYear===currentYear && selectedMonth < currentMonth) ){
        isPastSeries = true;
       }
    }
    this.setTurnaroundTimeText(isFutureSeries,isPastSeries)
  }
  setTurnaroundTimeText(isFutureSeries,isPastSeries){
    if(isFutureSeries && isPastSeries){
      this.setState({turnaroundTimeText: constants.TURNAROUND_TEXT.FURTURE_AND_PAST_SERIES})
    }
    else if(isFutureSeries && !isPastSeries){
      this.setState({turnaroundTimeText: constants.TURNAROUND_TEXT.FUTURE_SERIES})
    }
    if(isPastSeries  && !isFutureSeries){
      this.setState({turnaroundTimeText: constants.TURNAROUND_TEXT.PAST_SERIES})
    }
  }
  getMonthInNumberFormat(month){
    const monthArray={January:1,February:2,March:3,April:4,May:5,June:6,July:7,August:8,September:9,October:10,November:11,December:12}
    return monthArray[month];
  }

  hideModal = () => {
    this.setState({overlay:!this.state.overlay, modalType: ''})
    this.reDirectToHistory()
  }

    render(){
      const {acceptBtnDisable,checkDisable,spinner, modalType} = this.state,
            {nameFromHistory,userProfile,institutionDetailsList,institutionApivalues,mobileDevice,
                  transcriptRates,examDetailsList,examSeries,stateNavFlags,confirmationInfo,terms} = this.props,
            {pay} = constants.reviewAndPay,
            applicationSubmittedDate = UtilityService.convertUTCDateTimetoLocalDateTime(this.state.applicationSubmittedDate),
            paymentDueDate = UtilityService.convertUTCDateTimetoLocalDateTime(this.state.paymentDueDate),
            currentDateTime = moment(),
            isBreached = (paymentDueDate < currentDateTime),
            args = { payload: {
              data: {applicationReferenceNumber: this.state.applicationReferenceNumber, paymentDueDate: this.state.paymentDueDate, transactionId: this.state.orderId}
            }};

        return(
            <React.Fragment>            
            <div className="w-100">
            {spinner && 
              <Spinner animation="grow" size="xl" role="status" className="elem-to-center">
                  <span className="sr-only">Loading...</span>
              </Spinner>}
            <StepForm pathname={this.props.location.pathname}></StepForm>          
              <div className="card mt-2">  
                  <div className="card-body">                        
                        <label className='head-label'>Order summary</label>
                        <div className='mt-2'>
                          <span className="sub-label mr-2">Order number:</span><span>{this.state.orderId}</span>
                          <div className='mt-3'>
                            <span className="sub-label mr-2">Application submitted date:</span><span>{applicationSubmittedDate && moment(applicationSubmittedDate).format('DD MMMM yyyy')}</span>
                          </div>
                          <div className='mt-3'>
                            <span className="sub-label mr-2">Payment due date:</span><span>{paymentDueDate && moment(paymentDueDate).format('DD MMMM yyyy, HH:mm')}</span>
                          </div>
                        </div>
                        <div className='mt-3'>                        
                          <span className="sub-label mr-2">Student name:</span>{!isEmpty(nameFromHistory.fNameFromHistory) ? 
                                                                                nameFromHistory.fNameFromHistory+" "+nameFromHistory.lNameFromHistory:
                                                                                userProfile?.given_name+" "+userProfile?.family_name }
                          <div className='mt-3'><span className="sub-label mr-2">Email:</span>{userProfile?.email}</div>
                          <div className='pl-3 row mb-3 mt-3'>
                            <div className="sub-label">Exam(s):</div>
                              <div className={mobileDevice?'col-12 mV-p':'col-10'}>                        
                                {stateNavFlags.isHistoryPayNav ? examSeries.map((item,index) => {
                                  return(<div key={index} className="sectionLabel mb-3">
                                            <div className="mb-0">{item.session}</div>
                                            <div className="mb-0">{constants.EXAM_DETAILS.EXAM_NAME}</div>
                                            <div className="mb-0">{item.centreName}</div>
                                        </div>  
                                        )}):                    
                                examDetailsList.length>0 && examDetailsList.map((item,index) => {
                                  return(<div key={index} className="sectionLabel mb-3">
                                          <div className="mb-0">{item.examSeries.month}  {item.examSeries.year}</div>
                                          <div className="mb-0">{item.exam}</div>
                                          <div className="mb-0">{item.examCenter}</div>
                                      </div>) 
                                })}
                              </div>
                          </div>
                          <div className='pl-3 row'>
                              <div className="sub-label">Institutions:</div>
                                <div className={mobileDevice?'col-12 mV-p':'ml-minus-5 col-10'}>
                                  {stateNavFlags.isHistoryPayNav ? institutionApivalues.map((item,i) => {
                                    return(<div key={i} className="sectionLabel mb-2"><span className="mb-0">{item}</span></div>) 
                                  }):                                  
                                  institutionDetailsList.length>0 && institutionDetailsList.map(item => {
                                    return(<div key={item.id} className="sectionLabel mb-2"><span className="mb-0">{item.institute.split(',')[0]}</span></div>)    
                                  })}
                                </div>
                          </div>                        
                        </div>                       

                        <div className='mt-3'><span className="head-label mr-2">Fee: $</span>{transcriptRates.totalTranscriptAmount.toFixed(2)}</div>

                        <div className="head-label mt-4"><span >{pay.tc1}</span></div>
                        <span className="font-italic mb-0">{pay.tc2}</span>
                        <div className="mt-3 pl-3 row">
                          <div><input id='termsAcceptance' disabled={checkDisable} type="checkbox" className="c-b-size" onClick={() => this.acceptTerms(confirmationInfo.requestId)} /></div>
                            <div className="col-11">
                              <div id='scroll' className="t-area" 
                                   onScroll={this.scrollToBottom} 
                                   dangerouslySetInnerHTML={{__html:terms +'\n' + this.state.turnaroundTimeText}}></div>
                            </div>
                        </div>
                        <div>      
                          <div className="head-label mt-4"><span >You will need:</span></div>
                            <div>
                              <ul>
                                <li>{pay.need1}</li>
                                <li>{pay.need2}</li>
                              </ul>
                          </div>  
                        </div>
                        <div className="row mt-3">
                          <div className='col-10'>
                            After payment is received, grade transcripts will be sent within 14 days.
                            If you include a future exam series in the request, transcripts will be sent within 14 days of future results release day.
                            If you have a query about your application, contact Customer Services by emailing <a href="mailto:info@cambridgeinternational.org">info@cambridgeinternational.org</a> or call 917-810-2660 (toll free, open 24 hours).
                          </div>
                          <div className='col-2'></div>
                        </div>
                    </div>
              </div>
            </div>      
            <div className="mt-3 mb-2">              
              <button disabled={acceptBtnDisable || isBreached} onClick={(e) => this.handleButtonClick(e, args)}  className="btn font-weight-bold save-button-review text-white payBtn mr-3" id="submit1">{'Accept and pay >>'}</button>
              <button id="payLater" onClick={this.reDirectToHistory} type="button" className="btn btn-link font-weight-bold mt-1 text-decoration-none cancel"><span>Pay later</span></button>
            </div>
            <div className='mt-2'><span className="confirm-warning">{pay.warning1}</span></div>
            <div className='mt-3 mb-3'><span className="confirm-warning">{pay.warning2}</span></div>
            <div id='printModalContent'>                
              <Modal show={this.state.overlay} hideModal={this.hideModal} rec={modalType} mobile={mobileDevice} />
            </div>
        </React.Fragment>
      );
  }
}
const mapStateToProps = state => {
  return{
    userProfile: state.currentUser.profile,
    nameFromHistory: state.currentUser,    
    institutionDetailsList : state.institutesDetailsInfo.institutesDetailList,
    institutionApivalues : state.institutesDetailsInfo.institutionApivalues,
    transcriptRates : state.reviewConfirm,
    confirmationInfo : state.ConfirmationInfo,
    examDetailsList : state.examDetailsInfo.examDetailsList,
    examSeries : state.examDetailsInfo.examSeriesApiValues,
    stateNavFlags : state.stateTransition,
    terms : state.termsAndConditionsReducer.conditionsApiText,
    mobileDevice: state.commonData.mobileDevice
  }
}

const mapDispachToProps =  {  
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails,
  resetReviewDetails,
  acceptedTermsAndConditions,
  getTermsAndConditions,
  getExamSeriesError,
  getInstitutionsError,
  updateAdyenFlag
};
export default withRouter(connect(mapStateToProps,mapDispachToProps)(TermsAndConditions));
